var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgForBusinessman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 112.78 120.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ativo 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.66,67.43c-6.88-5.9-17.1-8.42-30.41-7.5A32.81,32.81,0,1,0,36.08,59c-9.6-1-29.84-.24-36,21.08a2.26,2.26,0,0,0-.1.69v37.26a2.5,2.5,0,0,0,2.49,2.5h107.8a2.49,2.49,0,0,0,2.49-2.5V82.42A23,23,0,0,0,104.66,67.43Zm-77-34.62A28.13,28.13,0,1,1,55.94,60.93h-.27A28.15,28.15,0,0,1,27.68,32.81ZM55.31,70.93h2.41l3.55,7.35-4.86,9.46L52.78,80.6Zm-3-5A1.68,1.68,0,0,1,54,64.26h4.73a1.68,1.68,0,0,1,0,3.35H54A1.68,1.68,0,0,1,52.35,65.93Zm8.76,4.38a5,5,0,0,0,2.64-4.38,5.16,5.16,0,0,0-.17-1.25,32.77,32.77,0,0,0,5.7-2L63.17,74.58ZM52,70.49l-1.48,5.65-6.46-12.7a32.29,32.29,0,0,0,5.08,1.5,5.36,5.36,0,0,0-.1,1A5,5,0,0,0,52,70.49Zm55.81,45.07H5V81.15c6.24-20.81,28.7-17.76,34-16.73L54.17,94.34a2.5,2.5,0,0,0,2.22,1.36h0a2.49,2.49,0,0,0,2.22-1.35L73.73,65c12.32-1,21.6,1.09,27.6,6.17a18.09,18.09,0,0,1,6.47,11.52Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgForBusinessman);
export default __webpack_public_path__ + "static/media/imgForBusinessman.aa4e57b22dbde08819ab1503e294ffce.svg";
export { ForwardRef as ReactComponent };